<template>
  <div class="d-flex flex-column flex-root login-body">
      <div class="login-signin-on d-flex flex-column flex-lg-row flex-column-fluid">
          <div class="container-fluid flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden" style="padding: 0% 4% 0% 4% !important;">
              <div class="login-main d-flex flex-column-fluid align-items-center">
                  <div class="login-img-left align-self-end"><img src="../assets/images/login_left.svg" class="img-fluid"></div>
                  <div class="login-form mx-auto login_width">
                      <div class="text-center logo_login"><a href="../../public/index.html"><img src="../assets/images/logo.png" alt="logo"></a></div>
                      <div class="text-center title-login">
                          <h1 class="f36-bold">Welcome to Flowz Workforce Monitoring System</h1>
                          <p class="fs-18">Enter your details to continue.</p>
                      </div>
                      <form v-on:submit.prevent="onButtonTap" action="#">
                          <div class="mb-4">
                              <label class="form-label">Username</label>
                              <input type="text" class="form-control" placeholder="name@company.com" v-model="login.email" id="exampleInputEmail1" aria-describedby="emailHelp">
                          </div>
                          <div class="mb-4">
                              <label class="form-label">Password</label>
                              <input type="password" class="form-control" placeholder="Enter password" v-model="login.password" id="exampleInputPassword1">
                          </div>
                          <div class="mb-4 d-flex justify-content-between">
                              <div class="form-check custm_checkbox">
                                  <input class="form-check-input" type="checkbox" value="" id="exampleCheck1">
                                  <label class="form-check-label" style="padding-left:15%" for="exampleCheck1">RememberMe</label>
                              </div>
                              <a href="#" class="fs-16 blue_txt_clr frgnt_pswrd">Forgot Password?</a>
                          </div>
                          <div class="mb-4">
                              <button type="submit" class="getflowz_btn try_nw w-100">Login Now</button>
                          </div>
                          <div class="text-center">
                              <p class="fs-16 dnt_hvact">Don't have an account? <a style="text-decoration: none !important;color: #088BFF;" @click="redirectPage()">Register Now</a></p>
                          </div>
                      </form>
                  </div>
                  <div class="login-img-right align-self-start"><img src="../assets/images/login_right.svg" class="img-fluid"></div>
              </div>
          </div>
      </div>
  </div>
  <!-- <div class="login-main">
    <div class="login-box">
      <div class="text-center">   </div>
      <div class="login-under">
        <form v-on:submit.prevent="onButtonTap" action="#">
          <div class="form-group">
            <label for="exampleInputEmail1">Username</label>
            <input v-model="login.email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email">
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">Password</label>
            <input v-model="login.password" type="password" class="form-control" id="exampleInputPassword1" placeholder="Password">
          </div>
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="exampleCheck1">
            <label class="form-check-label" for="exampleCheck1">Check me out</label>
          </div>
          <button type="submit" class="btn btn-primary w100" >Log in</button>
        </form>
        <div><router-link to="/signup" class="btn btn-link pull-right">Sign Up</router-link></div>
      </div>
    </div>
  </div>	 -->
</template>


<script>
/* eslint-disable */
import login from '../api/login'
import Record from './Record.vue'
import Cookies from 'js-cookie'
import userdetails from '../api/userdetail'
import JobListing from './JobListing.vue'


export default {
	name: 'Login',
	props: {

  },
  components: {
  },
	data() {
		return {
      login: {
        email: '',
        password: ''
      }
		}
  },
  methods: {
    redirectPage () {
      this.$router.push('/signup')
    },
    validateEmail(email) {
      // console.log(">>>>>>")
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    onButtonTap : async function(args) {
      // this.$navigateTo(Index)  
      let emailValidator = await this.validateEmail(this.login.email)
      let self = this;
      if(self.login.email == ""){
        this.$Notice.error({ title: 'Error', desc: 'Email required!', duration: 3 })
        // console.log("Email required");
      } else if(emailValidator == false) {
        this.$Notice.error({ title: 'Error', desc: 'Email is not valid!', duration: 3 })
        // console.log("Email is not valid", "long");
      } else if (self.login.password == "") {
        this.$Notice.error({ title: 'Error', desc: 'Password required!', duration: 3 })
        // console.log("Password required", "long");
      } else {
        let formdata = {
          "email": self.login.email,
          "password": self.login.password
        }
        // console.log("Email:", self.login.email)
        // console.log("Password:", self.login.password)
        login.post(formdata).then((response) => {
          // console.log('Success',response)
          Cookies.set('auth_token', response.data.logintoken)

          userdetails.post({'email': formdata.email}).then((response) => {
            Cookies.set('userId', response.data.data[0]._id)

            // Change in future - store to VueX
            Cookies.set('emailId',response.data.data[0].email)

            Cookies.set('role',response.data.data[0].role)

            if(Cookies.get('role') === 'Admin'){
              self.$router.push({
                name: 'job-listing'
              })
            }
            else{
              self.$router.push({
                name: 'record'
              })

            }



            // console.log("userdetail",response)
          }).catch((err) => {
            // alert(err.response.data)
            this.$Notice.error({ title: 'Error', desc: err.response.data, duration: 3 })
            // console.log("Error:",err.response.data)
          })

          
          // console.log("Response:", response)
        }).catch((err)=> {
          // alert(err.response.data)
          this.$Notice.error({ title: 'Error', desc: err.response.data, duration: 3 })
          // console.log("Error:",err.response.data)
        })

        // userdetails.post({'email': formdata.email}).then((response) => {
        //   Cookies.set('userId', response.data.data[0]._id)

        //   // Change in future - store to VueX
        //   Cookies.set('emailId',response.data.data[0].email)


        //   // console.log("userdetail",response)
        // }).catch((err) => {
        //   alert(err.response.data)
        //   console.log("Error:",err.response.data)
        // })
        
      }
      
    }

  }
}
</script>

<style scoped>
</style>